export {};
//# sourceMappingURL=Box.types.js.map